import * as actions from './actions';
import messages from '../student-roll/messages';

const assignEmptyStudentObject = () => (
    { firstName: '', lastName: '', yearGroupEnum: '', userName: '', password: '' }
);

const initialState = { studentDetail: assignEmptyStudentObject(), updatingStudent: false, isLoadingEditStudentDetail: false, showModal: false };

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_STUDENTS_REQUEST: {
        return { ...state, isLoadingEditStudentDetail: action.isLoadingEditStudentDetail };
    }

    case actions.GET_STUDENTS_SUCCESS: {
        return { ...state, editStudentDetail: action.data, isLoadingEditStudentDetail: action.isLoadingEditStudentDetail, studentDetail: action.data };
    }
    case actions.EDIT_STUDENT_REQUEST:
    {
        return { ...state, updatingStudent: true };
    }
    case actions.EDIT_STUDENT_SUCCESS_REQUEST:
    {
        return { ...state, updatingStudent: false, studentDetail: assignEmptyStudentObject() };
    }
    case actions.EDIT_STUDENT_FAILURE_REQUEST:
    {
        let errorMessage = '';
        if (action.isServerError) {
            errorMessage = messages.errorMessageHeader;
        } else {
            errorMessage = action.editStudentValidationMessage;
        }
        return { ...state, updatingStudent: false, showEditStudentValidationModal: action.showEditStudentValidationModal, editStudentValidationMessage: errorMessage };
    }
    case actions.CLOSE_EDIT_STUDENT_VALIDATION_MODAL:
    {
        return { ...state, showEditStudentValidationModal: action.showEditStudentValidationModal };
    }

    case actions.GET_STUDENTS_FAILURE: {
        return { ...state, editStudentDetail: [], isLoadingEditStudentDetail: action.isLoadingEditStudentDetail };
    }

    case actions.OPEN_UNASSIGN_STUDENTS_MODAL: {
        return { ...state, isUnassignedModalOpen: action.isUnassignedModalOpen };
    }

    case actions.UNASSIGN_STUDENTS_USING_CLASSID_REQUEST: {
        return { ...state, unassignDisableButton: action.unassignDisableButton, isUnassignedModalOpen: action.isUnassignedModalOpen };
    }

    case actions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS: {
        return { ...state, isUnassignedModalOpen: action.isUnassignedModalOpen, unassignDisableButton: action.unassignDisableButton };
    }

    case actions.UNASSIGN_STUDENTS_USING_CLASSID_FAILURE: {
        return { ...state, unassignDisableButton: action.unassignDisableButton };
    }

    case actions.CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION: {
        return { ...state, refreshStudentsAfterUnAssign: action.refreshStudentsAfterUnAssign };
    }

    case actions.SHOW_HIDE_MODAL: {
        return { ...state, showModal: action.showModal };
    }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/containers/edit-student/reducer.js